<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\liveCourseManual-1.png" alt="" /></div>
                <div>
                    <p>①.「ライブ講義」アイコンをクリックすると、オンラインコースのリストが表示されます。</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;新しい「ライブ講義」があると、アイコンの右隅に通知が表示されます。</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;当日の全てのライブ講義はディフォルトで初期表示されます。</p>
                    <p>②.ライブ講義名称をキーワードとして対象するライブ講義を検索することができます。</p>
                    <p>③.ステータス（すべて、終了、ライブ中、未開始）でライブ講義を絞ることができます。</p>
                    <p>④.講義の開始日、終了日でライブ講義を絞ることができます。</p>
                    <p>⑤.「検索」ボタンを押下することで検索処理を開始します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①.画面下部の「ライブ講義」アイコンをクリックします。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_1.png" alt="" /></div>
                <div><p>②.当日の全てのライブ講義はディフォルトで初期表示されます。ライブ講義を検索したい場合に、「講義名称」、「ステータス」、「講義期間」に情報を入力し、「検索」ボタンをすることで検索してください。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/searchLiveCourse_manual.vue